import * as actions from '../actions'

var defaultState = null

export default function transactions(state = defaultState, action) {
    switch (action.type) {

        case actions.TRANSACTIONS_GET:
            if (!action.error) {
                state = action.payload.data.objects
            }
            return state

        case actions.TRANSACTIONS_CLEAN:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/transactions.js